<script>
    import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';

    let showNotification = false;

    function closeNotification() {
        showNotification = false;
    }

    onMount(() => {
        // Show the notification once on mount
        showNotification = true;
    });
</script>

{#if showNotification}
    <div 
        class="notification-wrapper fixed top-0 left-0 w-full h-full flex-center z-notification"
        transition:fade={{ duration: 200 }}
    >
        <div class="notification-backdrop absolute top-0 left-0 w-full h-full"></div>
        
        <div class="notification-container relative p-0 z-notification-content">
            <div class="notification-header flex flex-justify-between flex-align-center">
                <h2 class="notification-title m-0">Cloud Demo Notice</h2>
                <button 
                    class="close-button cursor-pointer" 
                    on:click={closeNotification} 
                    aria-label="Close notification"
                >×</button>
            </div>
            <div class="notification-body">
                <p class="notification-message">
                    This is a limited cloud-based demo and should not be used with client information.  
                    Please use Internet Edge, Google Chrome, or some other Chromium-based browser.
                    Please reach out to <strong>hello@fearn.ai</strong> regarding cloud-free installation.
                </p>
            </div>
        </div>
    </div>
{/if}

<style>
    .notification-wrapper {
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .notification-backdrop {
        z-index: 9998;
        background-color: var(--color-notification-backdrop);
    }

    .notification-container {
        z-index: 9999;
        width: 90%;
        max-width: 500px;
        background-color: var(--color-notification-body-bg);
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    }

    .notification-header {
        padding: 1.5rem;
        background-color: var(--color-notification-header-bg);
        border-radius: 12px 12px 0 0;
        border-bottom: 1px solid var(--color-notification-header-border);
    }

    .notification-title {
        font-size: 1.25rem;
        font-weight: 600;
        color: var(--color-notification-text-primary);
    }

    .close-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        padding: 0.5rem;
        font-size: 1.5rem;
        color: var(--color-notification-close-btn);
        background: none;
        border: none;
        border-radius: 6px;
        transition: color 0.2s ease;
    }

    .close-button:hover {
        color: var(--color-notification-close-btn-hover);
        background-color: var(--color-notification-close-btn-bg-hover);
    }

    .notification-body {
        padding: 1.5rem;
    }

    .notification-message {
        margin: 0;
        font-size: 1rem;
        line-height: 1.6;
        color: var(--color-notification-text-secondary);
    }

    .notification-message strong {
        color: var(--color-notification-text-emphasis);
    }

    /* Utility classes */
    .fixed {
        position: fixed;
    }

    .absolute {
        position: absolute;
    }

    .relative {
        position: relative;
    }

    .top-0 {
        top: 0;
    }

    .left-0 {
        left: 0;
    }

    .w-full {
        width: 100%;
    }

    .h-full {
        height: 100%;
    }

    .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flex {
        display: flex;
    }

    .flex-justify-between {
        justify-content: space-between;
    }

    .flex-align-center {
        align-items: center;
    }

    .p-0 {
        padding: 0;
    }

    .m-0 {
        margin: 0;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .z-notification {
        z-index: 9999;
    }

    .z-notification-content {
        z-index: 10000;
    }
</style>